import { useEffect, useState } from "react";
import { ArrowUpRight, Gift } from "lucide-react";
import { api } from "@/lib/api";

const URL = "https://www.halfalaser.it";
const PINK = "#D6337F";
const YELLOW = "#F2E33A";
let cache = null;
export const resetPromoCache = () => { cache = null; };

function usePromo() {
  const [p, setP] = useState(cache);
  useEffect(() => {
    if (cache) return;
    api.get("/promo/halfalaser").then((r) => { cache = r.data; setP(r.data); }).catch(() => {});
  }, []);
  return p;
}

export function HalfaLaserStrip() {
  const p = usePromo();
  if (!p?.enabled) return null;
  return (
    <a href={URL} target="_blank" rel="noopener noreferrer" data-testid="halfalaser-strip" style={{ backgroundColor: PINK, borderBottomColor: YELLOW }}
      className="group block text-white border-b-4 hover:brightness-105 transition-[filter] duration-200">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 py-2 sm:py-2.5 flex flex-wrap items-center justify-center sm:justify-between gap-x-4 gap-y-1.5 text-center sm:text-left">
        <p className="text-sm flex items-center gap-2" data-testid="halfalaser-strip-text">
          <Gift className="w-4 h-4 shrink-0" style={{ color: YELLOW }} />
          <span><b style={{ color: YELLOW }}>{p.highlight}</b>{p.text && <span className="hidden sm:inline"> · {p.text}</span>}</span>
        </p>
        <span data-testid="halfalaser-strip-cta" style={{ backgroundColor: YELLOW, color: PINK }}
          className="inline-flex items-center gap-1 h-8 px-4 rounded-full text-xs font-extrabold uppercase tracking-wide">
          {p.cta} <ArrowUpRight className="w-3.5 h-3.5 transition-transform duration-200 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
        </span>
      </div>
    </a>
  );
}

export function HalfaLaserBox({ where }) {
  const p = usePromo();
  if (!p?.enabled || !p[`show_${where}`]) return null;
  return (
    <a href={URL} target="_blank" rel="noopener noreferrer" data-testid={`halfalaser-box-${where}`}
      className="group mt-10 flex items-center gap-4 rounded-xl border-2 bg-white p-4 hover:shadow-md transition-shadow duration-200" style={{ borderColor: PINK }}>
      <div className="w-11 h-11 rounded-lg grid place-items-center shrink-0" style={{ backgroundColor: PINK }}><Gift className="w-5 h-5" style={{ color: YELLOW }} /></div>
      <div className="flex-1 min-w-0">
        <div className="font-extrabold uppercase text-sm" style={{ color: PINK }}>Regali personalizzati su halfalaser.it</div>
        <div className="text-sm text-slate-600">{p.text || p.highlight}</div>
      </div>
      <ArrowUpRight className="w-5 h-5 shrink-0 transition-transform duration-200 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" style={{ color: PINK }} />
    </a>
  );
}
